import {
  useSettingPDPPrefetchOnTouch,
  useAssignSettingPDPPrefetchOnTouch,
} from "@faire/retailer-visitor-shared/settings/useSettingPDPPrefetchOnTouch";
import {
  usePreloadNavigationToPDP,
  ProductDetails,
} from "@faire/retailer-visitor-shared/views/product/preload/preloadNavigationToPDP";
import { useCallback } from "react";

export const usePrefetchOnTouch = (
  productData: ProductDetails,
  productPageUrl: string
) => {
  const { productToken, bestImage, images, brandToken, showVerticalImagery } =
    productData;

  const prefetchPdpApiOnTouch = useSettingPDPPrefetchOnTouch();
  const assignPdpPrefetchOnTouch = useAssignSettingPDPPrefetchOnTouch();
  const preloadNavigationToPDP = usePreloadNavigationToPDP();

  const onTouchStart = useCallback(() => {
    if (!productToken) {
      return;
    }
    assignPdpPrefetchOnTouch();
    if (prefetchPdpApiOnTouch) {
      preloadNavigationToPDP(
        {
          productToken,
          bestImage,
          images,
          brandToken,
          showVerticalImagery,
        },
        productPageUrl
      );
    }
  }, [
    productToken,
    bestImage,
    images,
    brandToken,
    showVerticalImagery,
    assignPdpPrefetchOnTouch,
    prefetchPdpApiOnTouch,
    preloadNavigationToPDP,
    productPageUrl,
  ]);

  return { onTouchStart };
};
